/** Persists this browser's cloud-auth session across reloads — structurally the same load/store/clear shape as `apps/desktop`'s own `lib/cloud-auth/cloud-session.ts`. */

const STORAGE_KEY = "stagvista.admin-console.cloud-session";

export interface CloudSession {
  readonly accessToken: string;
  readonly refreshToken: string;
  /** When `accessToken` expires, in epoch ms — `Date.now() + expiresInSeconds * 1000` at issue/refresh time. */
  readonly expiresAt: number;
}

export function loadCloudSession(): CloudSession | null {
  const raw = window.localStorage.getItem(STORAGE_KEY);
  if (!raw) return null;
  try {
    return JSON.parse(raw) as CloudSession;
  } catch {
    return null;
  }
}

export function storeCloudSession(session: CloudSession): void {
  window.localStorage.setItem(STORAGE_KEY, JSON.stringify(session));
}

export function clearCloudSession(): void {
  window.localStorage.removeItem(STORAGE_KEY);
}
